var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "template",
        { slot: "header" },
        [
          _c("TabelToolBar", {
            ref: "TabelToolBar",
            on: {
              onHandlePrint: _vm.onHandlePrint,
              onHandleAuditOrder: _vm.onHandleAuditOrder,
              onUnCheckBillOrder: _vm.onUnCheckBillOrder,
              onCancelBillOrder: _vm.onCancelBillOrder,
              nextOrder: _vm.nextOrder,
              getBackOrder: _vm.getBackOrder,
              onSaveEditOrder: _vm.onSaveEditOrder,
              onBeforeShowAddRowDialogForaddOrder:
                _vm.onBeforeShowAddRowDialogForaddOrder,
              onClickEditOrder: _vm.onClickEditOrder,
              onHandleExportDetailData: _vm.onHandleExportDetailData,
              onSaveAddOrder: _vm.onSaveAddOrder,
              onSendMail: _vm.onSendMail,
              onHandleCancel: _vm.onHandleCancel,
              onHandelAddRow: _vm.onHandelAddRow
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "MaintainDeliveryNote2-Edit" },
        [
          _vm.isShowTabelHeaderForNewOrder
            ? _c("TabelHeaderForNewOrder", {
                ref: "TabelHeaderForNewOrder",
                on: { validateHeaderSuccess: _vm.validateHeaderSuccess }
              })
            : _vm._e(),
          _vm.isShowTabelHeaderForEdit
            ? _c("TabelHeaderForEdit", {
                ref: "TabelHeaderForEdit",
                on: { onBeforeSaveEditOrder: _vm.onBeforeSaveEditOrder }
              })
            : _vm._e(),
          _c("EditTable", {
            ref: "EditTable",
            on: {
              upDateTableBar: _vm.upDateTableBar,
              onUpdataOrderStaus: _vm.onUpdataOrderStaus,
              onSuccessSave: _vm.onSuccessSave,
              cbCreateOrderSuccess: _vm.cbCreateOrderSuccess
            }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }